<div class="ivr-section">
    <button mat-raised-button
        color="primary"
        [disabled]="!agentId"
        (click)="ivrTransfer()"
    >
        Transfer To IVR
    </button>
</div>
